<template>
  <v-menu
    :close-on-content-click="false"
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-btn icon small class="ml-6 mr-1">
        <v-icon color="white" v-bind="attrs" v-on="on">mdi-account-circle</v-icon>
      </v-btn>
    </template>
    <v-card v-if="user">
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-account-circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="d-block mr-4">
            <v-list-item-title>{{ user.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="logout">Logout</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { ref } from '@vue/composition-api';
import { getToken, getUser, getLogoutUrl } from '@/utils/auth';

export default {
  name: 'UserInfo',
  setup () {
    const user = ref(null);

    getUser(getToken(), window.location.origin).then(data => {
      user.value = data;
    });

    const logout = () => {
      window.location.href = getLogoutUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID, window.location.origin);
    };

    return { user, logout };
  }
};
</script>
